import cookie from 'react-cookie';
import * as subscriptionApi from '../../common/api/subscription';

export const CHANGE_PLANS = 'redux/subscription/CHANGE_PLANS';
export const CHANGE_PLANS_SUCCESS = 'redux/subscription/CHANGE_PLANS_SUCCESS';
export const CHANGE_PLANS_FAIL = 'redux/subscription/CHANGE_PLANS_FAIL';
export const CANCELLATION_PROGRESS = 'redux/subscription/CANCELLATION_PROGRESS';

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case CHANGE_PLANS:
      return {
        ...state,
        changingPlans: true,
        changePlansSuccess: false,
        changePlansError: false,
      };
    case CHANGE_PLANS_SUCCESS:
      return {
        ...state,
        currentSubscriptionForBrand: action.result.currentSubscriptionForBrand,
        upcomingInvoice: action.result.upcomingInvoice,
        changingPlans: false,
        changePlansSuccess: true,
        changePlansError: false,
      };
    case CHANGE_PLANS_FAIL:
      return {
        ...state,
        changingPlans: false,
        changePlansSuccess: false,
        changePlansError: action.error,
      };
    case CANCELLATION_PROGRESS:
      return {
        ...state,
        cancelStep: action.cancelStep,
      };
    default:
      return state;
  }
}
export function changePlans(planId, subscription) {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CHANGE_PLANS });
      if (cookie.load('access_token')) {
        const accessToken = getState().session.accessToken || cookie.load('access_token');
        const subInfo = { planId, subscription };
        const subResponse = await subscriptionApi.updateSubscription(accessToken, subInfo);
        const currentSubscriptionForBrand = subResponse.userAccount.subscriptions.find(sub =>
          sub.subscriptionId === subscription && sub.stripePlanId === planId);
        const result = { currentSubscriptionForBrand, upcomingInvoice: subResponse.upcomingInvoice };
        return dispatch({ type: CHANGE_PLANS_SUCCESS, result });
      }
    } catch (error) {
      return dispatch({ type: CHANGE_PLANS_FAIL, error });
    }
  };
}

export function showCancellationProgress(cancelStep) {
  return async dispatch => dispatch({ type: CANCELLATION_PROGRESS, cancelStep });
}
